import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import TimelineContainer from 'custom_modules/FieldServices/RouteMapNew/Timeline/timelineContainer';
import { CardText } from 'components/DashboardCards/cardStyles';
import { TimelineBorder, TimelineInfoContainer, TimelineTextSection } from 'custom_modules/FieldServices/RouteMapNew/routeMapStyles';
import { CommonImage } from 'styledComponents/common';
import checkedIn from 'assets/img/icons/checked-in.svg';
import checkedOut from 'assets/img/icons/checked-out.svg';
import clockedIn from 'assets/img/icons/clocked-in.svg';
import clockedOut from 'assets/img/icons/clocked-out.svg';

const getEventDetails = event => {
  switch (event) {
    case 'clock_in':
      return { iconName: clockedIn, eventName: 'clock_in', eventDisplay: 'clock_in' };
    case 'clock_out':
      return { iconName: clockedOut, eventName: 'clock_out', eventDisplay: 'clock_out' };
    case 'checkin':
      return { iconName: checkedIn, eventName: 'checkin', eventDisplay: 'enter' };
    case 'checkout':
      return { iconName: checkedOut, eventName: 'checkout', eventDisplay: 'exit' };
    default:
      // Return a default object instead of null to prevent destructuring errors
      return { iconName: clockedIn, eventName: 'unknown_event', eventDisplay: 'unknown_event' };
  }
};

const AttendanceTimelineElement = ({ event, timestamp, lat, long, task, last }) => {
  const { t } = useTranslation();

  const { iconName, eventName, eventDisplay } = useMemo(
    () => getEventDetails(event),
    [event],
  );

  // Remove this check since we now always return a valid object
  // if (!iconName || !eventName) return null;

  return (
    <div key={timestamp} style={{ display: 'flex'}}>
      <CardText name fontSize="13px" title margin="5px 0 0 0" style={{ width: '85px', gap: '10px' } }>
        {timestamp !== 0 ? moment.unix(timestamp).format('h:mm A') : '-- : --'}
      </CardText>
      <TimelineInfoContainer>
        <CommonImage src={iconName} alt="" />
        <CardText fontSize="12px" name title>
          {t(eventDisplay)}
        </CardText>
        {!last ? <TimelineBorder /> : <div />}

        {task && task.id ? (
          <TimelineTextSection>
            <CardText fontSize="12px" name fontWeight="500">
              {`${t('task')}: ${task.name}`}
            </CardText>
            {task.location && task.location.id && (
              <CardText fontSize="13px" label fontWeight="500">
                {task.location.address}
              </CardText>
            )}
          </TimelineTextSection>
        ) : (
          <div style={{ height: '20px' }} />
        )}
      </TimelineInfoContainer>
    </div>
  );
};

export default AttendanceTimelineElement;

